import { render, staticRenderFns } from "./GuestLayout.vue?vue&type=template&id=cdf52c56"
import script from "./GuestLayout.vue?vue&type=script&lang=js"
export * from "./GuestLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/www-root/data/www/view.sessiondesign.ru/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cdf52c56')) {
      api.createRecord('cdf52c56', component.options)
    } else {
      api.reload('cdf52c56', component.options)
    }
    module.hot.accept("./GuestLayout.vue?vue&type=template&id=cdf52c56", function () {
      api.rerender('cdf52c56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/front/shared/views/layouts/GuestLayout.vue"
export default component.exports